import { avatarMaker } from './avatar_maker.js';

class AccountCard {
  constructor({ id = 0, name = '', email = '', avatar = '' }) {
    this.#id = id;
    this.#name = name;
    this.#email = email;
    this.#avatar = avatar;
  }

  get id() {
    return this.#id;
  }

  get name() {
    return this.#name;
  }

  set name(v) {
    this.#name = v;
  }

  get email() {
    return this.#email;
  }

  set email(v) {
    this.#email = v;
  }

  get avatar() {
    return this.#avatar || avatarMaker.get(this.#name);
  }

  set avatar(v) {
    this.#avatar = v;
  }

  toString() {
    return `'${this.name}'<${this.email}>:${this.id}`;
  }

  #avatar;
  #id;
  #email;
  #name;
}

export { AccountCard };
